import React, { useEffect, lazy, Suspense } from 'react';
import { Routes, Route, Link, useLocation } from "react-router-dom";
import { Card } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
//User Functions
import { useGetLanguages, useGetConfigCompetitions } from 'helpers/commonCodes';
import { useGetPath } from 'helpers/urlFriendly';
import { getDisciplines, getH1, getNocs, getRoutes, getSportsCodes, getUrls, getParticipantNames, useObtainDataArray } from 'data/Querys';
import { useAbsoluteRoot } from 'helpers/urlRoot';

//User Components
import MainContainer from 'components/common/main-container/MainContainer';
import Loader, { LoaderEntry } from './Loader';
import NotAvailable from 'components/common/NotAvailable';
//user Pages

/*
import Results from 'pages/Results'; //lazy inside this component by sport
import { useQueries, useSuspenseQueries } from '@tanstack/react-query';
const Athletes = lazy(() => import('pages/Athletes'));
const AthletesByNoc = lazy(() => import('pages/AthletesbyNoc'));
const CompetitionStatus = lazy(() => import('pages/CompetitionStatus'));
const BioDetail = lazy(() => import('pages/BioDetail'));
const Bracket = lazy(() => import('pages/Bracket'));
const Coach = lazy(() => import('pages/Coach'));
const Coaches = lazy(() => import('pages/Coaches'));
const EventRanking = lazy(() => import('pages/EventRanking'));
const Entries = lazy(() => import('pages/Entries'));
const EntriesByDiscipline = lazy(() => import('pages/EntriesByDiscipline'));
const EntriesByNoc = lazy(() => import('pages/EntriesByNoc'));
const HearingSchedule = lazy(() => import('pages/HearingSchedule'));
const Horse = lazy(() => import('pages/Horse'));
const Horses = lazy(() => import('pages/Horses'));
const LiveIndividualMatches = lazy(() => import('pages/LiveIndividualMatches'));
const LiveTeamMatches = lazy(() => import('pages/LiveTeamMatches'));

const Medal = lazy(() => import('pages/Medal'));
const Medallists = lazy(() => import('pages/Medallists'));
const MedallistsByNoc = lazy(() => import('pages/MedallistsByNoc'));
const MultiMedallists = lazy(() => import('pages/MultiMedallist'));
const NocEntriesByEvent = lazy(() => import('pages/NocEntriesByEvent'));
const NocList = lazy(() => import('pages/NocList'));
const Official = lazy(() => import('pages/Official'));
const PoolStanding = lazy(() => import('pages/PoolStandingContext'));
const Placings = lazy(() => import('pages/Placings'));
const ProfilesByNoc = lazy(() => import('pages/ProfileByNoc'));
const Records = lazy(() => import('pages/Records'));
const Reports = lazy(() => import('pages/Reports'));
const Schedule = lazy(() => import('pages/Schedule'));
const ScheduleByDay = lazy(() => import('pages/ScheduleByDay'));
const ScheduleByNoc = lazy(() => import('pages/ScheduleByNoc'));
const ScheduleGrid = lazy(() => import('pages/ScheduleGrid'));
const Team = lazy(() => import('pages/Team'));
const Teams = lazy(() => import('pages/Teams'));
const TechnicalOfficials = lazy(() => import('pages/TechnicalOfficials'));
const TodayMatches = lazy(() => import('pages/TodayMatches'));
*/


import Athletes from 'pages/Athletes';
import AthletesByNoc from 'pages/AthletesbyNoc';
import CompetitionStatus from 'pages/CompetitionStatus';
import BioDetail from 'pages/BioDetail';
import Bracket from 'pages/Bracket';
import Coach from 'pages/Coach';
import Coaches from 'pages/Coaches';
import EventRanking from 'pages/EventRanking';
import Entries from 'pages/Entries';
import EntriesByDiscipline from 'pages/EntriesByDiscipline';
import EntriesByNoc from 'pages/EntriesByNoc';
import HearingSchedule from 'pages/HearingSchedule';
import Horse from "pages/Horse";
import Horses from 'pages/Horses';
import Medal from 'pages/Medal';
import Medallists from 'pages/Medallists';
import MedallistsByNoc from 'pages/MedallistsByNoc';
import MultiMedallists from 'pages/MultiMedallist';
import NocEntriesByEvent from 'pages/NocEntriesByEvent';
import NocList from 'pages/NocList';
import Official from 'pages/Official';
import PoolStanding from 'pages/PoolStandingContext';
import Placings from 'pages/Placings';
import ProfilesByNoc from 'pages/ProfileByNoc';
import Records from 'pages/Records';
import Reports from 'pages/Reports';
import Results from 'pages/Results'; //lazy inside this component by sport
import Schedule from 'pages/Schedule';
import ScheduleByDay from 'pages/ScheduleByDay';
import ScheduleByNoc from 'pages/ScheduleByNoc';
import ScheduleGrid from 'pages/ScheduleGrid';
import Team from 'pages/Team';
import Teams from 'pages/Teams';
import TechnicalOfficials from 'pages/TechnicalOfficials';
import TodayMatches from 'pages/TodayMatches';
import { useGetRawParamsFromPath } from 'helpers/urlRoot';
import { isSwitchHost } from 'helpers/utils';
import Redirect from './Redirect';


function NoMatch() {  
    return (
        <Card>
            <Card.Header>Error MIRS</Card.Header>
            <Card.Body>
                <Card.Title>Problem</Card.Title>
                <Card.Text>
                    <Link to="/">Go to the home page</Link>
                </Card.Text>
            </Card.Body>
        </Card>
    );
}

function ApplicationRouter() {
    //Get values friendly from URL 
    let { mirs_competition, mirs_language } = useGetRawParamsFromPath()
    let langIsoCode = mirs_language

    const dataLanguage = useGetLanguages()
    let mlanguage = dataLanguage?.languages?.find(item => item.langIsoCode === mirs_language?.toUpperCase())?.lang

    if (!mlanguage) {
        mlanguage = mirs_language
        langIsoCode = dataLanguage?.languages?.find(item => item?.lang === mirs_language?.toUpperCase())?.langIsoCode?.toLowerCase()
    }

    const dataCompetitions = useGetConfigCompetitions()
    let mcompetition = dataCompetitions?.competitions?.find(item => item.path === mirs_competition)?.competitionCode || mirs_competition

    import(`styles/${mcompetition}/variables.scss`);

    //load data related lenguage change
    const { isError: isErrorDataLanguage, isLoading: isLoadingDataLanguage } = useLoadDataLanguage(mlanguage, langIsoCode, mcompetition)

    //load data related competition change
    const { isError: isErrorDataLanguageCompetition, isLoading: isLoadingDataLanguageCompetition } = useLoadDataLanguageCompetition(mlanguage, mcompetition)

    //Wait load all files neccesary in memory 
    if (isLoadingDataLanguage || isLoadingDataLanguageCompetition) { return <LoaderEntry />; }
    if (isErrorDataLanguage || isErrorDataLanguageCompetition) { return <NotAvailable />; }



    return (
        //Load Routes related to language
        <RoutesMemo lang={mlanguage} />
    )
}


const LoadRoutes = (props) => {
    let comp = [];
    let obj = useGetPath();
    let objUrl = obj(props.lang);
    let index = 0;

    comp.push(
        <Route key={`RouteAthletes${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathAthletes}`} element={<Athletes />} >
            <Route path={`:mirs_discipline/`} element={<Athletes />} />
            <Route path={`:mirs_discipline/:mirs_noc`} element={<Athletes />} />
        </Route>
    )

    comp.push(
        <Route key={`RouteTeams${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathTeams}`} element={<Teams />} >
            <Route path={`:mirs_discipline/`} element={<Teams />} />
            <Route path={`:mirs_discipline/:mirs_noc`} element={<Teams />} />
            <Route path={`:mirs_discipline/:mirs_noc/:mirs_event`} element={<Teams />} />
        </Route>
    )

    comp.push(
        <Route key={`RouteCoaches${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathCoaches}`} element={<Coaches />} >
            <Route path={`:mirs_discipline/`} element={<Coaches />} />
            <Route path={`:mirs_discipline/:mirs_noc`} element={<Coaches />} />
            <Route path={`:mirs_discipline/:mirs_noc/:mirs_event`} element={<Coaches />} />
        </Route>
    )

    comp.push(
        <Route key={`RouteTechnicalOfficials${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathTechnicalOfficials}`} element={<TechnicalOfficials />} >
            <Route path={`:mirs_discipline/`} element={<TechnicalOfficials />} />
        </Route>
    )

    comp.push(
        <Route key={`RouteHorses${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathHorses}`} element={<Horses />} >
            <Route path={`:mirs_noc`} element={<Horses />} />
        </Route>
    )

    comp.push(
        <Route key={`RouteEntries${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathEntries}`} element={<Entries />} >
            <Route path={`:mirs_discipline/`} element={<Entries />} />
            <Route path={`:mirs_discipline/:mirs_noc`} element={<Entries />} />
            <Route path={`:mirs_discipline/:mirs_noc/:mirs_event`} element={<Entries />} />
        </Route>
    )

    comp.push(
        < Route key={`RouteEntriesByDisciplines${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathEntriesDiscipline}`} element={< EntriesByDiscipline />} >
            <Route path={`:mirs_discipline`} element={<Entries />} />
            <Route path={`:mirs_discipline/:mirs_noc`} element={<Entries />} />
        </Route>
    )
    comp.push(
        < Route key={`RouteNocEntriesByEvent${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathNocEntriesByEvent}`} element={< NocEntriesByEvent />} >
            <Route path={`:mirs_discipline/:mirs_noc`} element={<NocEntriesByEvent />} />
        </Route>
    )


    comp.push(<Route key={`RouteBioDetail${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathBio}/:mirs_code`} element={<BioDetail />} />)
    comp.push(<Route key={`RouteTeam${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathTeam}/:mirs_code`} element={<Team />} />)
    comp.push(<Route key={`RouteCoach${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathCoach}/:mirs_code`} element={<Coach />} />)
    comp.push(<Route key={`RouteHorse${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathHorse}/:mirs_code`} element={<Horse />} />)
    comp.push(<Route key={`RouteOfficial${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathOfficial}/:mirs_code`} element={<Official />} />)


    comp.push(<Route key={`RouteBracket${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathBracket}/:mirs_discipline/:mirs_event/`} element={<Bracket />} />)

    comp.push(<Route key={`RouteEventRanking${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathRanking}/:mirs_discipline/:mirs_event/`} element={<EventRanking />} />)

    comp.push(<Route key={`RoutePoolStanding${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathPool}/:mirs_discipline/:mirs_event/`} element={<PoolStanding />} />)
    
    const MedalElement = isSwitchHost() ? Redirect : Medal;
    comp.push(
        <Route key={`RouteMedal${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathMedal}`} element={<MedalElement redirection="medal" />} >
            <Route path={`:mirs_discipline`} element={<MedalElement redirection="medal" />} />
        </Route>
    )

    comp.push(
        <Route key={`RouteMedallists${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathMedallists}`} element={<Medallists />} >
            <Route path={`:mirs_discipline`} element={<Medallists />} />
            <Route path={`:mirs_discipline/:mirs_event`} element={<Medallists />} />
            <Route path={`:mirs_discipline/:mirs_event/:mirs_date`} element={<Medallists />} />
        </Route>
    )

    comp.push(
        <Route key={`RouteMultiMedallists${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathMultiMedallists}`} element={<MultiMedallists />} >
            <Route path={`:mirs_discipline`} element={<MultiMedallists />} />
        </Route>
    )

    comp.push(<Route key={`RouteNocList${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathNocList}`} element={<NocList />} />)
    comp.push(<Route key={`RoutePlacings${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathPlacing}/:mirs_discipline/`} element={<Placings />} />)

    comp.push(
        <Route key={`RouteRecords${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathRecords}`} element={<Records />} >
            <Route path={`:mirs_discipline`} element={<Records />} >
                <Route path={`:mirs_event`} element={<Records />} />
            </Route>
        </Route>
    )

    comp.push(
        <Route key={`RouteReports${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathReports}`} element={<Reports />} >
            <Route path={`:mirs_discipline`} element={<Reports />} />
            <Route path={`:mirs_discipline/:mirs_event`} element={<Reports />} />
        </Route>
    )
    comp.push(
        <Route key={`RouteResults${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathResult}/:mirs_discipline/:mirs_event/:mirs_rsc/`} element={<Results />} />
    )

    const ScheduleElement = isSwitchHost() ? Redirect : Schedule
    comp.push(
        <Route key={`RouteSchedule${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathSchedule}`} element={<ScheduleElement redirection="schedule"/>} >
            <Route path={':mirs_discipline'} element={<ScheduleElement redirection="schedule"/>} >
                <Route path={':mirs_date'} element={<ScheduleElement redirection="schedule"/>} >
                    <Route path={':mirs_event'} element={<ScheduleElement redirection="schedule"/>} />
                </Route>
            </Route>
        </Route>
    )

    comp.push(<Route key={`RouteScheduleGrid${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathCompetitionschedule}/`} element={<ScheduleGrid />} />)
    comp.push(<Route key={`RouteScheduleByDay${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathCompetitionscheduleByDay}/:mirs_date`} element={<ScheduleByDay />} />)

    const ScheduleByNocElement = isSwitchHost() ? Redirect : ScheduleByNoc
    comp.push(
        <Route key={`RouteScheduleByNoc${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathScheduleByNoc}/:mirs_noc`} element={<ScheduleByNocElement redirection="scheduleByNoc" />} >
            <Route path={`:mirs_discipline`} element={<ScheduleByNocElement redirection="scheduleByNoc" />} >
                <Route path={`:mirs_date`} element={<ScheduleByNocElement redirection="scheduleByNoc" />} >
                    <Route path={`:mirs_event`} element={<ScheduleByNocElement redirection="scheduleByNoc" />} />
                </Route>
            </Route>
        </Route>
    )
    comp.push(<Route key={`RouteEntriesByNoc${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathEntriesByNoc}/:mirs_noc`} element={<EntriesByNoc />} />)

    const MedallistByNocElement = isSwitchHost() ? Redirect : MedallistsByNoc
    comp.push(<Route key={`RouteMedallistsByNoc${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathMedallistsByNoc}/:mirs_noc`} element={<MedallistByNocElement redirection="medallistsByNoc" />} />)

    comp.push(<Route key={`RouteProfileByNoc${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathProfileByNoc}/:mirs_noc`} element={<ProfilesByNoc />} />)
    comp.push(
        <Route key={`RouteAthletesByNoc${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathAthletesByNoc}/:mirs_noc`} element={<AthletesByNoc />} >
            <Route path={`:mirs_discipline`} element={<AthletesByNoc />} />
        </Route>
    )

    comp.push(<Route key={`RouteTodayMatches${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathTodayMatches}/:mirs_discipline/:mirs_date`} element={<TodayMatches />} />)
    comp.push(<Route key={`RouteTodayMatchesAthleteDate${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathTodayAthMatches}/:mirs_discipline/:mirs_date`} element={<TodayMatches type={'A'} />} />)
    comp.push(<Route key={`RouteTodayMatchesTeamDate${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathTodayTeamMatches}/:mirs_discipline/:mirs_date`} element={<TodayMatches type={'T'} />} />)

    comp.push(<Route key={`RouteCompetitionStatus${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathCompetitionStatus}/:mirs_discipline`} element={<CompetitionStatus />} />)
    comp.push(<Route key={`RouteHearingSchedule${index}`} path={`/:mirs_language/:mirs_competition/${objUrl.pathFriendly.pathHearingSchedule}/:mirs_discipline`} element={<HearingSchedule />} />)


    return (
        <>
            <Routes>
                <Route path="*" element={<NoMatch />} />
                <Route path="/" element={<MainContainer />}>
                    {comp}
                </Route>
            </Routes>
        </>
    )
};

const RoutesMemo = React.memo(LoadRoutes);

/*
Load data in memory  related to language  
*/
const useLoadDataLanguage = (mlanguage, langIsoCode, mirs_competition) => {
    const { urlRoot } = useAbsoluteRoot()
    const { i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(mlanguage.toLowerCase())
    }, [mlanguage])

    let queryArray = [];

    queryArray.push({
        queryKey: ['routerPaths', { router_language: mlanguage, urlRoot: mirs_competition ?  '/' + mirs_competition + '/' : urlRoot }],
        queryFn: getRoutes,
        refetchInterval: 0,
        staleTime: Infinity,
        //refetchIntervalInBackground: false,
        retry: false,
        //suspense: false,
        enabled: !!mlanguage

    })
    queryArray.push({
        queryKey: ['urlPaths', { router_language: langIsoCode, urlRoot: urlRoot, mirs_competition: mirs_competition }],
        queryFn: getUrls,
        refetchInterval: 0,
        staleTime: Infinity,
        retry: false,
        enabled: !!langIsoCode
    })


    const data = useObtainDataArray({ queries: queryArray });
    const isLoading = data.some(result => result.isLoading)
    const isError = data.some(result => result.isError)
    return ({ isLoading, isError, data })
}

/*Get Data Related languages and competition*/
const useLoadDataLanguageCompetition = (mlanguage, mcompetition) => {

    let queryArray = [];
    if (mcompetition) {

        queryArray.push({
            queryKey: ['CC_H1', mcompetition],
            queryFn: getH1,
            refetchInterval: 0,
            refetchIntervalInBackground: true,
            //enabled: !!mcompetition
        });

        queryArray.push({
            queryKey: ['CC_Disciplines', mcompetition, mlanguage?.toUpperCase()],
            queryFn: getDisciplines,
            refetchInterval: 0,
            refetchIntervalInBackground: true,

        })


        //Load data from SportCodes CC file
        queryArray.push({
            queryKey: ['SportCodes', mcompetition, mlanguage?.toUpperCase()],
            queryFn: getSportsCodes,
            refetchInterval: 0,
            refetchIntervalInBackground: true,

        })

        queryArray.push({
            queryKey: ['CC_Nocs', mcompetition, mlanguage?.toUpperCase()],
            queryFn: getNocs,
            refetchInterval: 0,
            refetchIntervalInBackground: true,

        })

        queryArray.push({
            queryKey: ['ParticipantNames', mcompetition, mlanguage?.toUpperCase()],
            queryFn: getParticipantNames,
            refetchInterval: 0,
            refetchIntervalInBackground: true,

        })

    }

    const data = useObtainDataArray({ queries: queryArray });
    const isLoading = data.some(result => result.isLoading)
    const isError = data.some(result => result.isError)



    return ({ isLoading, isError, data })

};

export default ApplicationRouter


